import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  FaHome, 
  FaFileInvoice, 
  FaUsers, 
  FaUserCog,
  FaChartBar,
  FaMoneyBillWave
} from 'react-icons/fa';
import './WFBackofficeSidebar.css';

const WFBackofficeSidebar = () => {
  return (
    <div className="wf-backoffice-sidebar">
      <div className="sidebar-brand">
        <img 
          src="/static/images/Wishfin-logo.png" 
          alt="Wishfin Logo" 
          className="sidebar-logo"
        />
        <span className="ms-2 fw-bold">Wishfin Backoffice</span>
      </div>
      <div className="sidebar-menu">
        <NavLink to="/wfbackoffice/dashboard" className={({isActive}) => isActive ? "sidebar-link active" : "sidebar-link"}>
          <FaHome className="sidebar-icon" />
          <span>Dashboard</span>
        </NavLink>
        <NavLink to="/wfbackoffice/invoices" className={({isActive}) => isActive ? "sidebar-link active" : "sidebar-link"}>
          <FaFileInvoice className="sidebar-icon" />
          <span>Invoices</span>
        </NavLink>
        <NavLink to="/wfbackoffice/dso-partners" className={({isActive}) => isActive ? "sidebar-link active" : "sidebar-link"}>
          <FaUsers className="sidebar-icon" />
          <span>DSO Partners</span>
        </NavLink>
        <NavLink to="/wfbackoffice/agents" className={({isActive}) => isActive ? "sidebar-link active" : "sidebar-link"}>
          <FaUserCog className="sidebar-icon" />
          <span>Agents</span>
        </NavLink>
      </div>
      <div className="sidebar-footer">
        <span className="text-muted small">© Wishfin Backoffice {new Date().getFullYear()}</span>
      </div>
    </div>
  );
};

export default WFBackofficeSidebar;